import { render, staticRenderFns } from "./edit-allocated-puppy-container.vue?vue&type=template&id=3a218ef8&scoped=true&lang=pug"
import script from "./edit-allocated-puppy-container.js?vue&type=script&lang=js&external"
export * from "./edit-allocated-puppy-container.js?vue&type=script&lang=js&external"
import style0 from "./edit-allocated-puppy-container.vue?vue&type=style&index=0&id=3a218ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a218ef8",
  null
  
)

export default component.exports